import { render } from "./BlogComponent.vue?vue&type=template&id=0ff2bfee&scoped=true"
import script from "./BlogComponent.vue?vue&type=script&lang=js"
export * from "./BlogComponent.vue?vue&type=script&lang=js"

import "./BlogComponent.vue?vue&type=style&index=0&id=0ff2bfee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff2bfee"]])

export default __exports__